import React, { useEffect, useState } from 'react';
import '../fonts.css';
import API_BASE_URL from '../api';

const ProfilePicture = () => {
  const [profilepic, setProfilePicture] = useState({ picture: '' });
  const [message, setMessage] = useState('');
  const getAuthToken = () => localStorage.getItem('stack_access_token');

  useEffect(() => {
    const token = getAuthToken();
    //fetch profile picture
    fetch(`${API_BASE_URL}/api/image`, {
      method: 'GET',
      headers: {
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Failed to fetch profile picture');
      })
      .then((image) => {
        // if (profilepic.picture === null) {
        //     profilepic.picture = '?'; // Set picture to an empty string
        // }
        setProfilePicture(image);
      })
      .catch((error) => {
        console.error('Failed to fetch profile picture', error);
        setMessage('Error fetching profile picture.');
      });
  }, []);

  const handleSaveImage = async (e) => {
    e.preventDefault();
    const token = getAuthToken();
    try {
      const response = await fetch(`${API_BASE_URL}/api/image/edit`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Stack-Access-Token': token,
        },
        body: JSON.stringify({ image_link: profilepic.picture }),
      });
      const updatedProfilePicture = await response.json();
      setProfilePicture(updatedProfilePicture);
      setMessage('Profile picture updated successfully.');
    } catch (err) {
      console.error('Failed to update profile picture.', err);
      setMessage('Failed to update profile picture.');
    }
  };

  const handleRemoveImage = async (e) => {
    e.preventDefault();
    const token = getAuthToken();
    try {
      const response = await fetch(`${API_BASE_URL}/api/image/remove`, {
        method: 'PUT',
        headers: {
          'X-Stack-Access-Token': token,
        },
      });
      if (response.status === 200) {
        setProfilePicture({ picture: '' });
        setMessage('Removed profile picture successfully.');
      } else {
        console.error('Failed to remove profile picture');
        setMessage('Failed to remove profile picture.');
      }
    } catch (err) {
      console.error('Failed to remove profile picture', err);
      setMessage('Failed to remove profile picture.');
    }
  };

  const handleChange = (e) => {
    const value = e.target.value || '';
    console.log('Input Value:', value);
    setProfilePicture({
      ...profilepic,
      picture: value,
    });
  };

  return (
    <div className="bg-bggreen">
      <div
        className="max-w-md w-full mx-auto p-8 rounded-lg shadow-md"
        style={{ backgroundColor: '#05664f' }}
      >
        <h1
          className="text-5xl font-bold text-white text-center mb-6"
          style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
        >
          Profile Picture{' '}
        </h1>
        <div className="space-y-6">
          {message && (
            <p className="text-sm text-red-200 text-center">{message}</p>
          )}
          <form onSubmit={handleSaveImage} className="space-y-4">
            <div>
              <input
                type="text"
                name="picture"
                value={profilepic.picture}
                onChange={handleChange}
                className="w-96 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                style={{ color: '#0d2329' }}
                placeholder="Upload Profile Picture here"
              />
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              style={{ backgroundColor: '#000000' }}
            >
              UPDATE
            </button>
          </form>
          <button
            type="button"
            onClick={handleRemoveImage}
            className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            style={{ backgroundColor: '#000000' }}
          >
            REMOVE PICTURE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePicture;
